import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useEngagementPlatform } from './useEngagementPlatform';

/**
 * Hook that returns an announcement banner configuration for the
 * given Engagement Platform external message id and text.
 *
 * If message should not be displayed, hook returns undefined.
 */
export function useEngagementPlatformAnnouncementBanner(messageId, text) {
  var _useEngagementPlatfor = useEngagementPlatform(),
    stopMessage = _useEngagementPlatfor.stopMessage,
    startMessage = _useEngagementPlatfor.startMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isStarted = _useState2[0],
    setIsStarted = _useState2[1];
  useEffect(function () {
    startMessage(messageId).then(function (isStarted) {
      setIsStarted(isStarted);
    });
  }, [messageId, startMessage]);
  var handleClose = useCallback(function () {
    // We should hide message immediately without waiting for EngagementPlatform response
    setIsStarted(false);
    stopMessage(messageId);
  }, [messageId, stopMessage]);
  return useMemo(function () {
    if (isStarted) {
      return {
        id: messageId,
        text: text,
        onClose: handleClose
      };
    }
    return undefined;
  }, [messageId, text, handleClose, isStarted]);
}